export default function (req, res) {
  const redirects = [
    {
      from: '/contact',
      to: '/login'
    }
  ]

  console.log(req.headers)
  const redirect = redirects.find(r => r.from === req.url)

  // const redirect = redirects.find((r) => {
  //   debugger
  //   console.log(r.from, req.headers)
  //   if (r.from === req.url) {
  //     return true
  //   }
  //   return false
  // })

  if (redirect) {
    res.writeHead(302, { Location: redirect.to })
    res.end()
  }

  // else {
  //   next()
  // }
}
